export const zh = {
  returnLineItems: {
    refund: "退款",
    exchange: "换货",
    discount: "折扣",
  },
  returnStoreAddress: {
    mapButton: "在地图上查看",
  },
  returnRequestDate: {
    label: "您的退货申请已于 {{date}} {{time}} 提交",
  },
  actions: {
    continue: "继续",
  },
  "order-identification": {
    title: "追踪您的订单",
    description: "输入您的订单详情以追踪您的包裹",
    fields: {
      "zip-code": {
        title: "邮政编码",
        description: "输入您的送货邮政编码",
        required: "请输入邮政编码",
      },
      "tracking-number": {
        title: "订单号",
        description: "输入您的订单号",
        required: "请输入订单号",
      },
    },
    errors: {
      "unknown-order": {
        title: "订单号未知",
        description: "未找到该订单号，请检查后重试",
      },
      "order-not-shipped": {
        title: "订单准备中",
        description: "您的订单尚未发货",
      },
      "search-error": {
        title: "查询出错",
        description: "未能查找到订单。请稍后重试。",
      },
    },
  },
  delivery: "配送",
  "parcel-history": "包裹历史",
  "order-details": {
    title: "订单详情",
    "tracking-number": "追踪号",
    "order-number": "订单号",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "预计送达日期",
      deliveredOn: "送达日期",
      from: "从",
      to: "至",
    },
  },
  deliveryAddress: {
    title: "配送地址：",
    titlePickup: "自提点地址：",
    orderDetails: {
      title: "订单详情：",
      trackingNumber: "追踪号：",
      orderNumber: "订单号：",
      orderDate: "下单日期：",
    },
  },
  pickupPoint: {
    title: "自提点",
    openingHours: "营业时间：",
    closed: "已关闭",
    directions: "路线",
    days: {
      monday: "星期一：",
      tuesday: "星期二：",
      wednesday: "星期三：",
      thursday: "星期四：",
      friday: "星期五：",
      saturday: "星期六：",
      sunday: "星期日：",
    },
  },
  wallet: {
    warningNotEnabled: "您必须在店铺设置中启用钱包功能",
  },
  crossSell: {
    youMightAlsoLike: "您可能还喜欢",
  },
  "rate-order": {
    "order-recap": {
      title: "您的订单",
      "tracking-label": "追踪号：",
      "order-label": "订单号：",
    },
    form: {
      title: "评价您的配送",
      "rating-label": "为您的配送体验打分",
      "comment-label": "评论（可选）",
      "comment-placeholder": "与我们分享您的体验…",
      "submit-cta": "提交我的评价",
      "update-cta": "更新我的评价",
      "rating-required": "请选择一个评分。",
    },
    "thank-you": {
      title: "感谢您的反馈！",
      description:
        "您的评价已保存。这将帮助我们改善配送体验。",
    },
    errors: {
      "invalid-token": {
        title: "链接无效或已过期",
        description:
          "此链接已不再有效。请重新打开最新的追踪邮件。",
      },
      submit: {
        title: "出错了",
        description:
          "未能保存您的评价。请稍后重试。",
      },
    },
  },
  shippingInstructions: {
    colissimo: "您现在可以打印退货标签，并将包裹送至最近的Colissimo代收点。",
    chronoShop2Shop: "您现在可以打印退货标签，并将包裹送至最近的Chronopost代收点。",
    ups: "您现在可以打印退货标签，并将包裹送至最近的UPS代收点。",
    customerCarrier: "您现在可以将退货包裹交给您选择的承运商。",
    merchantCarrier: "我们将在1至3个工作日内通过电子邮件向您发送退货标签。",
    returnToStore: "您现在可以打印退货标签，并将包裹送至最近的门店。",
    malca: "您现在可以打印退货标签，并将包裹送至最近的Malca代收点。",
    tnt: "您现在可以打印退货标签，并将包裹送至最近的TNT代收点。",
    bonDeRetour: "您的退货单已准备好。您现在可以打印并用于退货。",
  },
  downloadLabel: {
    label: "下载我的标签",
    bonDeRetour: "下载我的退货单",
  },
} as const;
